import { DefaultNode } from './node.default'

export const nodeTypes = {
  defaultService: DefaultNode,
}
